<div
  class="bg-rune relative z-50 flex h-screen w-screen flex-col overflow-y-auto px-4 py-2 md:h-fit md:w-[800px]"
  (click)="$event.stopPropagation()"
>
  <app-select-item
    class="!w-full"
    [width]="760"
    [height]="160"
    [offsetY]="-48"
    *ngIf="!maskSearch"
    (selectItem)="onSelectItem($event)"
  ></app-select-item>
  <i class="fa fa-close absolute right-2 top-0 z-50 cursor-pointer text-2xl text-white" (click)="closeEdit.emit()"></i>
  <div class="-mt-4 flex w-full">
    <div class="hidden items-center p-2 md:flex">
      <div class="bg-gradient my-4 h-24 w-24 rounded-full border-2 border-gwt-brown shadow-xl">
        <img *ngIf="item" class="h-full w-full object-contain py-3 pl-3" [src]="getImageSource(item)" />
      </div>
    </div>
    <div class="flex flex-col gap-2 p-4" [formGroup]="form">
      <div class="flex flex-wrap gap-4 md:flex-nowrap">
        <div class="flex flex-col gap-2">
          <div class="font-semibold text-white">Order Type</div>
          <div class="flex">
            <button
              class="h-12 w-32 text-gwt-brown"
              [class.font-semibold]="form.get('orderType')?.value === OrderType.SELL"
              [class.bg-gwt-light]="form.get('orderType')?.value === OrderType.SELL"
              [class.bg-gwt-amber]="form.get('orderType')?.value !== OrderType.SELL"
              [class.text-gwt-light]="form.get('orderType')?.value !== OrderType.SELL"
              (click)="form.patchValue({ orderType: OrderType.SELL })"
            >
              <i
                class="fa self-center text-sm text-white"
                [ngClass]="{
                  'fa-circle': form.get('orderType')?.value !== OrderType.SELL,
                  'fa-circle-dot': form.get('orderType')?.value === OrderType.SELL
                }"
              ></i>
              Want To Sell
            </button>
            <button
              class="h-12 w-32 text-gwt-brown"
              [class.font-semibold]="form.get('orderType')?.value === OrderType.BUY"
              [class.bg-gwt-light]="form.get('orderType')?.value === OrderType.BUY"
              [class.bg-gwt-amber]="form.get('orderType')?.value !== OrderType.BUY"
              [class.text-gwt-light]="form.get('orderType')?.value !== OrderType.BUY"
              (click)="form.patchValue({ orderType: OrderType.BUY })"
            >
              <i
                class="fa self-center text-sm text-white"
                [ngClass]="{
                  'fa-circle': form.get('orderType')?.value !== OrderType.BUY,
                  'fa-circle-dot': form.get('orderType')?.value === OrderType.BUY
                }"
              ></i>
              Want To Buy
            </button>
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <div class="font-semibold text-white">Quantity</div>
          <div class="flex">
            <input
              class="h-12 w-24 border-none bg-gwt-light p-4 !text-xl text-gwt-brown placeholder-gwt-amber outline-none"
              type="number"
              formControlName="quantity"
              min="1"
            />
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <div class="font-semibold text-white">Visibility</div>
          <div class="flex">
            <button
              class="h-12 w-32 text-gwt-brown"
              [class.font-semibold]="!form.get('hidden')?.value"
              [class.bg-gwt-light]="!form.get('hidden')?.value"
              [class.bg-gwt-amber]="form.get('hidden')?.value"
              [class.text-gwt-light]="form.get('hidden')?.value"
              (click)="form.patchValue({ hidden: false })"
            >
              <i
                class="fa self-center text-sm text-white"
                [ngClass]="{
                  'fa-circle': form.get('hidden')?.value,
                  'fa-circle-dot': !form.get('hidden')?.value
                }"
              ></i>
              Visible
            </button>
            <button
              class="h-12 w-32 text-gwt-brown"
              [class.font-semibold]="form.get('hidden')?.value"
              [class.bg-gwt-light]="form.get('hidden')?.value"
              [class.bg-gwt-amber]="!form.get('hidden')?.value"
              [class.text-gwt-light]="!form.get('hidden')?.value"
              (click)="form.patchValue({ hidden: true })"
            >
              <i
                class="fa self-center text-sm text-white"
                [ngClass]="{
                  'fa-circle': !form.get('hidden')?.value,
                  'fa-circle-dot': form.get('hidden')?.value
                }"
              ></i>
              Hidden
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="isWeapon && formWeapon" class="flex flex-col gap-2" [formGroup]="formWeapon">
        <div class="flex flex-wrap gap-4 md:flex-nowrap">
          <div class="flex flex-col gap-2">
            <div class="font-semibold text-white">Attribute</div>
            <select
              class="h-12 w-64 border-none bg-gwt-light px-3 !text-xl text-gwt-brown outline-none"
              formControlName="attribute"
            >
              <option ngDisabled [ngValue]="'any'">Any/Default</option>
              <option *ngFor="let req of attributes" [ngValue]="req">{{ req }}</option>
            </select>
          </div>
          <div class="flex flex-col gap-2">
            <div class="font-semibold text-white">Req.</div>
            <input
              class="h-12 w-24 border-none bg-gwt-light p-4 !text-xl text-gwt-brown placeholder-gwt-amber outline-none"
              type="number"
              formControlName="requirement"
              min="0"
              max="13"
            />
          </div>
        </div>
        <div class="flex flex-wrap gap-4 md:flex-nowrap">
          <div class="flex flex-col gap-2">
            <div class="font-semibold text-white">Core</div>
            <select
              class="h-12 w-[368px] border-none bg-gwt-light px-3 !text-xl text-gwt-brown outline-none"
              formControlName="core"
            >
              <option ngDisabled [ngValue]="null">None</option>
              <option *ngFor="let core of weaponLists.core" [ngValue]="core">{{ core }}</option>
            </select>
          </div>
          <div class="flex flex-col gap-2">
            <div class="font-semibold text-white">Inscriptible Item</div>
            <div class="flex">
              <button
                class="h-12 w-32 text-gwt-brown"
                [class.font-semibold]="formWeapon.get('inscription')?.value"
                [class.bg-gwt-light]="formWeapon.get('inscription')?.value"
                [class.bg-gwt-amber]="!formWeapon.get('inscription')?.value"
                [class.text-gwt-light]="!formWeapon.get('inscription')?.value"
                (click)="formWeapon.patchValue({ inscription: true })"
              >
                <i
                  class="fa self-center text-sm text-white"
                  [ngClass]="{
                    'fa-circle': !formWeapon.get('inscription')?.value,
                    'fa-circle-dot': formWeapon.get('inscription')?.value
                  }"
                ></i>
                Inscription
              </button>
              <button
                class="h-12 w-32 text-gwt-brown"
                [class.font-semibold]="!formWeapon.get('inscription')?.value"
                [class.bg-gwt-light]="!formWeapon.get('inscription')?.value"
                [class.bg-gwt-amber]="formWeapon.get('inscription')?.value"
                [class.text-gwt-light]="formWeapon.get('inscription')?.value"
                (click)="formWeapon.patchValue({ inscription: false })"
              >
                <i
                  class="fa self-center text-sm text-white"
                  [ngClass]="{
                    'fa-circle': formWeapon.get('inscription')?.value,
                    'fa-circle-dot': !formWeapon.get('inscription')?.value
                  }"
                ></i>
                Classic
              </button>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap gap-4 md:flex-nowrap">
          <div class="flex flex-col gap-2">
            <div class="font-semibold text-white">Prefix</div>
            <select
              class="h-12 w-64 border-none bg-gwt-light px-3 !text-xl text-gwt-brown outline-none"
              formControlName="prefix"
            >
              <option ngDisabled [ngValue]="null">None</option>
              <option *ngFor="let prefix of weaponLists.prefix" [ngValue]="prefix">{{ prefix }}</option>
            </select>
          </div>
          <div class="flex flex-col gap-2">
            <div class="font-semibold text-white">Suffix</div>
            <select
              class="h-12 w-[368px] border-none bg-gwt-light px-3 !text-xl text-gwt-brown outline-none"
              formControlName="suffix"
            >
              <option ngDisabled [ngValue]="null">None</option>
              <option *ngFor="let suffix of weaponLists.suffix" [ngValue]="suffix">{{ suffix }}</option>
            </select>
          </div>
        </div>
      </div>
      <div *ngIf="isMiniature">
        <div class="flex w-full flex-col gap-2">
          <div class="font-semibold text-white">Dedication</div>
          <app-custom-toggle
            [form]="formOther"
            field="dedicated"
            labelTrue="Dedicated"
            labelFalse="Undedicated"
            size="w-64"
          ></app-custom-toggle>
        </div>
      </div>
      <div class="flex gap-4">
        <div class="flex w-full flex-col gap-2">
          <div class="font-semibold text-white">Description</div>
          <textarea
            class="h-12 w-full border-none bg-gwt-light p-2 !text-xl text-gwt-brown placeholder-gwt-amber outline-none"
            placeholder="Optional"
            formControlName="description"
          ></textarea>
        </div>
        <div class="flex w-[52px] flex-col gap-2">
          <div class="font-semibold text-white">Adv.</div>
          <i
            class="fa fa-gear cursor-pointer py-2 text-3xl text-white hover:text-gwt-light"
            title="Advanced order options"
            (click)="isAdvanced = !isAdvanced"
          ></i>
        </div>
      </div>
      <div *ngIf="isAdvanced" class="flex gap-4">
        <div class="flex flex-col gap-2">
          <div class="font-semibold text-white">Pre-Searing</div>
          <app-custom-toggle
            [form]="formOther"
            field="pre"
            labelTrue="Old-Ascalon"
            labelFalse="Normal"
            size="w-64"
          ></app-custom-toggle>
        </div>

        <div class="flex flex-col gap-2">
          <div class="font-semibold text-white">Legacy Item</div>
          <div class="flex">
            <button
              class="h-12 w-32 text-gwt-brown"
              [class.font-semibold]="!formWeapon.get('oldschool')?.value"
              [class.bg-gwt-light]="!formWeapon.get('oldschool')?.value"
              [class.bg-gwt-amber]="formWeapon.get('oldschool')?.value"
              [class.text-gwt-light]="formWeapon.get('oldschool')?.value"
              (click)="formWeapon.patchValue({ oldschool: false })"
            >
              <i
                class="fa self-center text-sm text-white"
                [ngClass]="{
                  'fa-circle': formWeapon.get('oldschool')?.value,
                  'fa-circle-dot': !formWeapon.get('oldschool')?.value
                }"
              ></i>
              Modern
            </button>
            <button
              class="h-12 w-32 text-gwt-brown"
              [class.font-semibold]="formWeapon.get('oldschool')?.value"
              [class.bg-gwt-light]="formWeapon.get('oldschool')?.value"
              [class.bg-gwt-amber]="!formWeapon.get('oldschool')?.value"
              [class.text-gwt-light]="!formWeapon.get('oldschool')?.value"
              (click)="formWeapon.patchValue({ oldschool: true })"
            >
              <i
                class="fa self-center text-sm text-white"
                [ngClass]="{
                  'fa-circle': !formWeapon.get('oldschool')?.value,
                  'fa-circle-dot': formWeapon.get('oldschool')?.value
                }"
              ></i>
              Old School
            </button>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <div class="flex gap-4 font-semibold text-white">
          <div class="w-52">Currency</div>
          <div class="w-20 md:w-36">Price per unit</div>
          <div class="w-20 md:w-40">Price for bundle</div>
        </div>
        <div class="flex flex-col gap-2" formArrayName="prices">
          <div
            class="flex items-center gap-4"
            *ngFor="let price of getprices().controls; let i = index"
            [formGroupName]="i"
          >
            <select
              class="h-12 w-52 border-none bg-gwt-light px-3 !text-xl text-gwt-brown outline-none"
              formControlName="type"
            >
              <option [ngValue]="Price.PLAT">Platinum</option>
              <option [ngValue]="Price.ECTO">Ectoplasm</option>
              <option [ngValue]="Price.ZKEY">Zaishen Key</option>
              <option [ngValue]="Price.ARM">Ambrace</option>
            </select>
            <input
              class="h-12 w-20 border-none bg-gwt-light p-4 !text-xl text-gwt-brown placeholder-gwt-amber outline-none md:w-36"
              type="number"
              formControlName="unit"
              min="0"
            />
            <input
              class="h-12 w-20 border-none bg-gwt-light p-4 !text-xl text-gwt-brown placeholder-gwt-amber outline-none md:w-48"
              type="number"
              formControlName="price"
              min="0"
            />
            <button
              class="h-12 w-12 bg-gwt-brown text-white"
              (click)="removePrice(i)"
              *ngIf="getprices().controls.length > 1"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="relative flex justify-between">
        <button class="h-12 w-52 bg-gwt-amber p-2 text-white" (click)="addPrice()">Add Another Currency</button>
        <button class="bg-button action mt-8 h-16 w-40 font-semibold text-white" (click)="validateOrder()">
          {{ confirm }}
        </button>
        <button
          class="bg-button action absolute bottom-0 right-44 h-8 w-24 font-semibold text-white"
          (click)="closeEdit.emit()"
        >
          Cancel
        </button>
      </div>
      <div class="h-80 w-full md:h-0"></div>
    </div>
  </div>
</div>
